import { ComponentProps, useCallback } from 'react';

import Box from '../../box/box';
import { Button } from '../../button/button';
import { Icon } from '../../icon';
import BaseIconButton from '../../icon-button/icon-button';
import Menu from '../../menu/menu';
import Select, { SelectChangeEvent } from '../../select/select';
import { styled } from '../../styles/styles';
import useFilterState from './use-filter-state';

interface SelectFilterProps {
  initialValue: string;
  onApplyFilter: (value: string) => void;
  onClearFilter: () => void;
  options?: ComponentProps<typeof Select>['options'];
}

const IconButton = styled(BaseIconButton)`
  svg {
    width: 18px;
    height: 18px;
  }
`;

const SelectFilter = ({
  initialValue,
  options,
  onApplyFilter,
  onClearFilter,
}: SelectFilterProps) => {
  const {
    open,
    handleClick,
    value,
    setValue,
    handleClose,
    anchorEl,
    isApplied,
    applyFilter,
    clearFilter,
  } = useFilterState(initialValue, onApplyFilter, onClearFilter);

  const onChange = useCallback(
    (event: SelectChangeEvent<any>) => {
      setValue(event.target.value);
    },
    [setValue]
  );

  return (
    <>
      <IconButton
        size="small"
        color={initialValue ? 'primary' : 'inherit'}
        onClick={handleClick}
      >
        <Icon name={'FilterAltOutlined'} />
      </IconButton>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <Box display="grid" gridTemplateRows="1fr" rowGap={2}>
          <Box minWidth={150}>
            <Select
              fullWidth
              label={''}
              placeholder="Search"
              size="small"
              value={value}
              onChange={onChange}
              options={options}
            />
          </Box>
          <Button
            variant="contained"
            fullWidth
            size="small"
            onClick={applyFilter}
          >
            Apply
          </Button>
          {isApplied && (
            <Button
              fullWidth
              size="small"
              variant="outlined"
              onClick={clearFilter}
            >
              Clear
            </Button>
          )}
        </Box>
      </Menu>
    </>
  );
};

export default SelectFilter;
